module.exports = __webpack_public_path__ + "static/media/donbosco13.0e2e3dc6.jpg";